/**
 * @generated SignedSource<<39004fde715b61ed0fa6416804c3e47a>>
 * @relayHash add064eb5664acacde5a1bbc9a7cd105
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2fbf7e4d946eb8606838c9b988aac8332823e9f24234db196b0536c2b142ac4f

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CodingAgentListInstalledAgentsQuery$variables = {
  cloudId: string;
};
export type CodingAgentListInstalledAgentsQuery$data = {
  readonly atlassianStudio_userSiteContext: {
    readonly userPermissions?: {
      readonly isJiraGlobalAdmin: boolean | null;
    } | null;
  } | null;
  readonly isSiteAdmin: boolean | null;
  readonly jira: {
    readonly jira_getAvailableCodingAgents: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly agent?: {
            readonly actionsRef?: {
              readonly " $fragmentSpreads": FragmentRefs<"AgentCardActions_StudioBrowseKit">;
            } | null;
            readonly id?: string;
            readonly name?: string | null;
          } | null;
          readonly user?: {
            readonly name: string;
          } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};
export type CodingAgentListInstalledAgentsQuery = {
  response: CodingAgentListInstalledAgentsQuery$data;
  variables: CodingAgentListInstalledAgentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "isSiteAdmin"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "AtlassianStudioUserProductPermissions",
      "kind": "LinkedField",
      "name": "userPermissions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isJiraGlobalAdmin"
        }
      ]
    }
  ],
  "type": "AtlassianStudioUserSiteContextOutput"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CodingAgentListInstalledAgentsQuery",
    "selections": [
      (v1/*: any*/),
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "atlassianStudio_userSiteContext",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraActorConnection",
            "kind": "LinkedField",
            "name": "jira_getAvailableCodingAgents",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraActorEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "agent",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "fragment": {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        {
                                          "kind": "FragmentSpread",
                                          "name": "AgentCardActions_StudioBrowseKit"
                                        }
                                      ],
                                      "type": "AgentStudioAssistant"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "actionsRef"
                                  }
                                ],
                                "type": "AgentStudioAssistant"
                              }
                            ]
                          }
                        ],
                        "type": "JiraAgenticUser"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CodingAgentListInstalledAgentsQuery",
    "selections": [
      (v1/*: any*/),
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "atlassianStudio_userSiteContext",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraActorConnection",
            "kind": "LinkedField",
            "name": "jira_getAvailableCodingAgents",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraActorEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v4/*: any*/),
                              (v5/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "agent",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v5/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                  },
                                  {
                                    "kind": "ClientExtension",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "__id"
                                      }
                                    ]
                                  }
                                ],
                                "type": "AgentStudioAssistant"
                              }
                            ]
                          }
                        ],
                        "type": "JiraAgenticUser"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "2fbf7e4d946eb8606838c9b988aac8332823e9f24234db196b0536c2b142ac4f",
    "metadata": {},
    "name": "CodingAgentListInstalledAgentsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2042f29485df81057ae19d472fdf9304";

export default node;
